import styled from "styled-components";
import {MbjLoading, MbjWidgetClassic} from "@mbj-front-monorepo/ui";
import {useParams} from "react-router-dom";
import {components, useGetResultsSearchEmployeeBySearch} from "@mbj-front-monorepo/data-access";
import {useEffect, useMemo, useState} from "react";
import {ResultEmployeeCard} from "./ResultEmployeeCard";

interface ResultEmployeeCtrlProps{
  className?:string;
  min:number;
  max:number;
  clickCompare:(result:components["schemas"]["ResultsSearchEmployee-resultssearchemployees.read_searchs.read_read.Member_read.UserMetier_read.Metier_read.Employee.simple_statutresult.read"])=>void;
}

const ResultEmployeeCtrl = (props:ResultEmployeeCtrlProps)=>{
  const {id} = useParams();
  const ResultsQuery = useGetResultsSearchEmployeeBySearch(id ? parseInt(id) : 0)

  const listResult = useMemo(()=>{
    if(!ResultsQuery.data){
      return [];
    } else {
      return ResultsQuery.data.filter(r=>{
        const CondMin = r.score && r.score >= props.min;
        const CondMax = r.score && r.score <= props.max;
        const CondNoStatut = r.statut?.id === 1
        return CondMax && CondMin && CondNoStatut;
      })
    }
  }, [ResultsQuery.data, props.min, props.max])
  return (
    <div className={"result_emp "+props.className}>
      <div className={"infos"}>Le nombre de résultats peut varier en fonction des profils déjà traités</div>
      <div className={"wrap_results"}>
        {ResultsQuery.isLoading ? (<MbjLoading/>) : ResultsQuery.isError ? 'Error data' :
          (
            <div className={"wrap_result"}>
              {listResult.map((item)=>(
                <ResultEmployeeCard key={`r${item.id}`} Search={item} clickCompare={props.clickCompare}/>
              ))}
            </div>
          )
        }
      </div>
    </div>
  )
}

export const ResultEmployee = styled(ResultEmployeeCtrl)`
  .wrap_result{
    display: flex;
    flex-wrap: wrap;
  }
`
